/**
 * Block cart checkout until custom-order terms are accepted.
 * The button enable/disable is CSS :has(:checked) — no disabled attribute (iOS Safari).
 */
(() => {
  const STORAGE_KEY = 'cart-terms-consented';

  const readConsent = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const persistConsent = (consented) => {
    try {
      if (consented) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // ignore
    }
  };

  const syncCheckboxes = () => {
    const consented = readConsent();
    document.querySelectorAll('[data-terms-checkbox]').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      if (consented && !input.checked) input.checked = true;
    });
  };

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.hasAttribute('data-terms-checkbox')) return;
      persistConsent(target.checked);
      document.querySelectorAll('[data-terms-checkbox]').forEach((input) => {
        if (input instanceof HTMLInputElement && input !== target) input.checked = target.checked;
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
      const checkbox = document.querySelector('[data-terms-checkbox]');
      if (checkbox instanceof HTMLInputElement && !checkbox.checked) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  const boot = () => syncCheckboxes();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:update', syncCheckboxes);
})();
